import { Reveal, Overline } from "./Reveal";
import { CLIENTS } from "../data/content";

export default function TrustedBy() {
  return (
    <section className="mx-auto max-w-7xl px-5 md:px-10 py-20" data-testid="home-trusted-by">
      <Reveal>
        <Overline className="text-gold">Trusted Across NSW</Overline>
        <h2 className="mt-4 font-heading font-black text-3xl md:text-5xl tracking-tight">
          PROUDLY CHOSEN BY <span className="gold-text">SCHOOLS, CLUBS &amp; COUNCILS.</span>
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {CLIENTS.map((c, i) => (
            <div key={c.name} data-testid={`client-${i}`}
              className="glass rounded-lg h-24 flex items-center justify-center px-4 hover:border-gold/40 transition-colors">
              {c.logo ? (
                <img src={c.logo} alt={c.name} className="max-h-12 w-auto opacity-70 grayscale hover:grayscale-0 hover:opacity-100 transition-all" />
              ) : (
                <span className="font-heading font-bold text-sm text-zinc-400 text-center">{c.name}</span>
              )}
            </div>
          ))}
        </div>
      </Reveal>
      <p className="mt-5 font-mono text-[10px] text-zinc-600">Real client logos are added by the Speedy team — a curated selection of partners served across Sydney &amp; NSW.</p>
    </section>
  );
}
